// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; 
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {

  apiKey: "AIzaSyA_GQAfko8E4vGPqXraoBmEJjy6TaBJYfw",

  authDomain: "foodapp-e1df3.firebaseapp.com",

  projectId: "foodapp-e1df3",

  storageBucket: "foodapp-e1df3.firebasestorage.app",

  messagingSenderId: "722546505052",

  appId: "1:722546505052:web:733b577bc3393944757d99"

};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);